import { AppFooter, AppHeader, AuthStatus, ErrorBoundary } from './components';
import { useExternalAuth } from './hooks/useExternalAuth';

export const ExternalAuthHandler = () => {
  const authState = useExternalAuth();

  return (
    <ErrorBoundary>
      <div className="flex min-h-screen flex-col">
        <AppHeader />
        <AuthStatus {...authState} />
        <AppFooter />
      </div>
    </ErrorBoundary>
  );
};
